export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11826.8078fe57.jpg";